import { Component, OnInit, ChangeDetectorRef, OnDestroy, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Attachment } from '@app/base/core/models';
import { SocoHttpService } from '@app/soco/http';
import { BuilderService } from '@app/modules/builder/base';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { SessionService, LookupsService, ConstantsService } from '@app/core/services';
import { AlertService } from '@app/base/alerts/alert.service';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.css']
})
export class AgreementsComponent implements OnInit, OnDestroy {
  // Kendo grid values

  setClickedRow: Function;
  public SearchResultsGridView: GridDataResult;
  StatusSearchResults: Attachment[];
  selectedRecord: Attachment = new Attachment();
  defaultSkip = 0;
  documentInput: any = {};
  defaultItemsPerPage = 10;
  public rowValue: string;
  public pageSizes = true;
  public previousNext = true;
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public take = 10;
  public state: State = {
    skip: this.defaultSkip,
    take: this.defaultItemsPerPage,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public mySelection: number[] = [];
  public position = this.constantsvc.position;
  public statevalue: SelectAllCheckboxState = 'unchecked';
  public items: any[];
  public queryParam: any;
  public killsubscribe: boolean;
  public companyName: string = null;

  public attachmentTitleValue: string;
  dropdownSettings: any;
  builderAttachmentForm: FormGroup;
  requestStatusForm: FormGroup;
  alertMsg: any = [];
  getAgreementsSubscription: Subscription;


  constructor(private cd: ChangeDetectorRef, private builderService: BuilderService,
    private session: SessionService, private config: SocoConfigurationService, private alertService: AlertService,
    public lookupSvc: LookupsService,   @Inject(Router) private router: Router,
    public socoHttp: SocoHttpService, public datepipe: DatePipe, public constantsvc: ConstantsService) {
    this.setClickedRow = function(index) {
      this.selectedRow = index;
    };
    this.killsubscribe = true;
    this.session.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
      if (success) {
        this.documentInput.Builder = success.CompanyName;
        this.documentInput.Folder = this.constantsvc.builderMarketerAgreement;
        this.companyName = success.CompanyName;
        this.getAgreementsSubscription = this.builderService.findFilesByMetadata(this.documentInput).subscribe(result => {
          if (result.data.length !== 0) {
            for ( let i = 0; i < result.data.length; i++) {
              if (result.data[i]['creationDate'] !== undefined) {
                result.data[i]['creationDate'] = new Date(this.datepipe.transform(result.data[i]['creationDate'], 'MM/dd/yyyy'));
              }
            }
            this.items = result.data,
            this.StatusSearchResults = this.items;


            this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
            this.socoHttp.hidePleaseWait('ContainerAwaiter');

          } else {
            this.StatusSearchResults = [];
            this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
            this.socoHttp.hidePleaseWait('ContainerAwaiter');
          }

          },
          error => {
            this.StatusSearchResults = [];
            swal(this.constantsvc.errorSwal1, this.constantsvc.docErrorSwal, this.constantsvc.errorSwal);
            this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
            this.socoHttp.hidePleaseWait('ContainerAwaiter');

          },
         );
        }
      });

    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Value',
      enableSearchFilter: true
    };
  }

  public ngOnInit() {
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    // Load common Lookups
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === this.constantsvc.bannermsgAgrements));
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.state = {
      skip: this.defaultSkip,
      take: this.take
    };
    this.requestStatusForm = new FormGroup({  // Init form
      requestId: new FormControl(''),
    }, { updateOn: 'blur' });
  }
// Binding data on statechange
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.take = state.take;
    this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
  }
  // For UnSubscriptions
  ngOnDestroy() {
    if (this.getAgreementsSubscription) {
      this.getAgreementsSubscription.unsubscribe();
    }
    this.killsubscribe = false;

  }
// Kendo grid selection change event
  selectionChange(ev: any) {
    this.rowValue = ev.index;
    this.selectedRecord = this.StatusSearchResults[this.rowValue];
  }
// Selected item
  public mySelectionKey(context: RowArgs): string {
    return context.dataItem.ProductName + ' ' + context.index;
  }
  // Submitform for searching the agreements
  submitForm() {
    let id = null;
    if (this.requestStatusForm.controls['requestId'].value != null) {
      id = this.requestStatusForm.controls['requestId'].value;
      this.documentInput.Name = id;
      this.documentInput.Builder = this.companyName;
      this.documentInput.Folder = this.constantsvc.builderMarketerAgreement;
    }
    this.getagreements();
  }
  // To refresh grid on click of refresh button
  refreshGrid() {
    this.requestStatusForm.patchValue({
      requestId: null
    });
    this.documentInput.Name = null;
    this.documentInput.Builder = this.companyName;
    this.documentInput.Folder = this.constantsvc.builderMarketerAgreement;
    this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter');
    this.getagreements();
  }
      // To go to builder home page
      navigateHome() {
        this.session.GetBcaData(null);
        this.router.navigate([
          this.session.paramLdc.toLowerCase(),
          'builder',
          'home'
          ]);
      }
  // To get marketer agreements
  getagreements() {
    this.getAgreementsSubscription = this.builderService.findFilesByMetadata(this.documentInput).subscribe(result => {
      if (result.data.length !== 0) {
        this.items = result.data,
      this.StatusSearchResults = this.items;
      this.StatusSearchResults.forEach(
        a => (a.creationDate = new Date(a.creationDate))
      );
      this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
      } else {
        this.StatusSearchResults = [];
        this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
        this.socoHttp.hidePleaseWait('ContainerAwaiter');
      }

    },
    error => {
      this.StatusSearchResults = [];
      swal(this.constantsvc.errorSwal1, this.constantsvc.docErrorSwal, this.constantsvc.errorSwal);
      this.SearchResultsGridView = process(this.StatusSearchResults, this.state);
      this.socoHttp.hidePleaseWait('ContainerAwaiter');
    }
    );
  }
}

